/**
 * @file Purchase PPD photos Photo Item component.
 */

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import pluralize from 'pluralize';
import get from 'lodash.get';

import PhotoObfuscated from '../global/obfuscation/PhotoObfuscated';
import Badge from '../global/Badge';
import { PPD_CART_ITEM_TYPES } from '../../constants/ppd-purchase';
import CustomControl from '../global/CustomControl';
import { getLargestFaceboxes } from '../../util/photo';

class PurchasePpdPhotosPhotoItem extends Component {
  static propTypes = {
    photoItem: PropTypes.shape({
      comparedFaces: PropTypes.arrayOf(PropTypes.arrayOf(PropTypes.number)),
      photo: PropTypes.shape({
        id: PropTypes.string,
        thumbnail_urls: PropTypes.arrayOf(
          PropTypes.shape({
            width: PropTypes.number,
            height: PropTypes.number,
            url: PropTypes.string,
          }),
        ),
      }),
    }),
    isSelected: PropTypes.bool,
    isDownloadEntitled: PropTypes.bool,
    isIndividualPrintPurchased: PropTypes.bool,
    isPrintPackagePurchased: PropTypes.bool,
    onClick: PropTypes.func.isRequired,
    cart: PropTypes.arrayOf(
      PropTypes.shape({
        type: PropTypes.oneOf(Object.keys(PPD_CART_ITEM_TYPES)),
        photo: PropTypes.shape({
          id: PropTypes.string,
        }),
        printSize: PropTypes.shape({
          id: PropTypes.string,
        }),
        printPackage: PropTypes.shape({
          id: PropTypes.string,
        }),
        quantity: PropTypes.number,
      }),
    ),
    onPhotoTouched: PropTypes.func,
    onPhotoClicked: PropTypes.func,
    showPricingTag: PropTypes.bool,
    disableSelection: PropTypes.bool,
  };

  render() {
    const {
      photoItem,
      isSelected,
      isDownloadEntitled,
      isIndividualPrintPurchased,
      isPrintPackagePurchased,
      onClick,
      cart,
      onPhotoTouched,
      onPhotoClicked,
      showPricingTag,
      disableSelection,
    } = this.props;

    const { photo, comparedFaces } = photoItem;

    const photoCartItems = cart.filter(
      cartItem =>
        get(cartItem, 'photo.id') === photo.id &&
        cartItem.type !== PPD_CART_ITEM_TYPES.SUBSCRIPTION,
    );
    const printItemsLength = photoCartItems.filter(
      cartItem => cartItem.type === PPD_CART_ITEM_TYPES.INDIVIDUAL_PRINT,
    ).length;
    const packageItemsLength = photoCartItems.filter(
      cartItem => cartItem.type === PPD_CART_ITEM_TYPES.PRINT_PACKAGE,
    ).length;
    const downloadItemsLength = photoCartItems.filter(
      cartItem => cartItem.type === PPD_CART_ITEM_TYPES.DOWNLOAD,
    ).length;

    return (
      <PhotoObfuscated
        id={photo.id}
        className={`mb-1 ${isSelected && 'photo-selected'}`}
        imgClassName="img-round"
        thumbs={photo.thumbnail_urls}
        faceboxes={getLargestFaceboxes(comparedFaces, 1)}
        onMouseDown={onPhotoTouched}
        onClick={onPhotoClicked}
        obfuscatorMultiplier={isDownloadEntitled ? 0 : 1}
        blockerMinSizeThreshold={0.005}
        blockerMinSize={0.3}
      >
        <div className="photo-messages">
          {isDownloadEntitled && <Badge>Download Purchased</Badge>}
          {isIndividualPrintPurchased && (
            <Badge>Purchased as Individual Print</Badge>
          )}
          {isPrintPackagePurchased && <Badge>Purchased as Print Package</Badge>}
          {packageItemsLength > 0 && (
            <Badge>
              {packageItemsLength} {pluralize('Package', packageItemsLength)} in
              Cart
            </Badge>
          )}
          {downloadItemsLength > 0 && <Badge>Download In Cart</Badge>}
          {printItemsLength > 0 && (
            <Badge>
              {printItemsLength} {pluralize('Print', printItemsLength)} in Cart
            </Badge>
          )}
        </div>
        {!disableSelection && (
          <div className="photo-selector">
            <CustomControl
              type="checkbox"
              id={`photo-${photo.id}`}
              className="photo-select-checkbox"
              size="xxl"
              label="Select this photo"
              labelSrOnly
              readOnly
              showHint
              checked={false}
              onChange={() => onClick(photoItem)}
            />
          </div>
        )}
        {showPricingTag && (
          <div className="photo-pricing-tag">
            <Badge badgeStyle="purple" badgeSize="xs">
              {get(photo, 'price_album_folder_tag.name')}
            </Badge>
          </div>
        )}
      </PhotoObfuscated>
    );
  }
}

export default PurchasePpdPhotosPhotoItem;
